import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ListIcon from '@mui/icons-material/List';

const Header: React.FC = () => {
  return (
    <AppBar position="static">
      <Toolbar>
        <DescriptionIcon sx={{ mr: 2 }} />
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Medical Document Processing
        </Typography>
        <Box>
          <Button color="inherit" component={RouterLink} to="/">
            Home
          </Button>
          <Button 
            color="inherit" 
            component={RouterLink} 
            to="/upload"
            startIcon={<UploadFileIcon />}
          >
            Upload
          </Button>
          <Button 
            color="inherit" 
            component={RouterLink} 
            to="/documents"
            startIcon={<ListIcon />}
          >
            Documents
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;